<template>
  <el-dialog
    top="80px"
    width="400px"
    class="create-user-popup"
    :title="price ? 'Thay đổi thông tin' : 'Thêm vị trí Banner'"
    :visible="visible"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" label-position="top">
      <el-form-item label="Giá tiền / 1 bài viết" prop="price">
        <el-input-number
          class="w-100"
          v-model="form.price"
          :min="1"
          :disabled="callingAPI"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="Số ngày hiển thị" prop="days">
        <el-input-number
          class="w-100"
          v-model="form.days"
          :min="1"
          :disabled="callingAPI"
        ></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="callingAPI" @click="handleClose">Hủy</el-button>
      <el-button type="primary" :loading="callingAPI" @click="handleUpdatePrice()">Lưu</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: 'PriceFormPopup',
  props: {
    visible: Boolean,
    price: Object
  },
  data() {
    return {
      callingAPI: false,
      form: this.price ? this.price : {
        price: 0,
        days: 7
      }
    }
  },
  computed: {
  },
  methods: {
    handleUpdatePrice() {
    },

    handleClose() {
      this.$refs.form.resetFields()
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped></style>
<style lang="scss">
</style>
